var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { HttpClient } from '@angular/common/http';
import { PaymentService } from '../payment.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP, URL_PAYMENT_PAYPAL_CREATE_ORDER_NORMAL, URL_PAYMENT_PAYPAL_CAPTURE_ORDER_NORMAL, URL_PAYMENT_PAYPAL_CREATE_ORDER_OCP, PAYMENT_METHOD_PAYPAL, PAYPAL_PAYMENT_RESULT } from '@ibe.config';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
var INDRAPaypalPaymentComponent = /** @class */ (function () {
    function INDRAPaypalPaymentComponent(store, storage, http, paymentService, flightPriceService, currencyService, indraPaymentService) {
        var _this = this;
        this.store = store;
        this.storage = storage;
        this.http = http;
        this.paymentService = paymentService;
        this.flightPriceService = flightPriceService;
        this.currencyService = currencyService;
        this.indraPaymentService = indraPaymentService;
        this.emitLoader = new EventEmitter();
        this.emitVoucherError = new EventEmitter();
        this.isAlive = true;
        this.userInfo$ = this.store.select(fromStore.getUserInfo);
        this.isLoggedIn = false;
        this.savePaypalChecked = false;
        this.formIsValid = false;
        this.isCaptureOrderOcpLoading = false;
        this.redeemVoucherAPICallFlag = true;
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (user) {
            if (user) {
                _this.isLoggedIn = true;
            }
        });
        this.paymentService.selectedMethod
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (selectedPaymentMethod) {
            if (selectedPaymentMethod) {
                _this.selectedPaymentMethod = selectedPaymentMethod;
            }
        });
        this.paymentService.formIsValid
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (formIsValid) {
            if (formIsValid != undefined) {
                _this.formIsValid = formIsValid;
            }
        });
        this.paymentService.savePaypalData
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (isSave) {
            if (isSave) {
                _this.savePaypalChecked = isSave;
            }
            else {
                _this.savePaypalChecked = isSave;
            }
        });
    }
    INDRAPaypalPaymentComponent.prototype.ngOnInit = function () {
        // this.INDRA_loadPaypalScripts();
        this.INDRA_initializeButtons();
    };
    INDRAPaypalPaymentComponent.prototype.INDRA_convertToCorrectDecimalPlace = function (cashPrice) {
        var decimalPlace = this.currencyService.INDRA_getDecimalPlaces();
        var cashPriceStr = decimalPlace > 0 ? cashPrice.toFixed(2) : this.flightPriceService.INDRA_convertToCorrectDecimalPlace(cashPrice.toString());
        return cashPriceStr;
    };
    INDRAPaypalPaymentComponent.prototype.INDRA_redeemVoucher = function () {
        var _this = this;
        if (this.promoCodesAndVoucher && this.promoCodesAndVoucher.length > 0) {
            var redeemVoucherSuccessFlag_1;
            var redeemVoucherResults_1 = [];
            if (this.redeemVoucherAPICallFlag) {
                this.redeemVoucherAPICallFlag = false;
                this.indraPaymentService.INDRA_redeemVoucher()
                    .pipe(takeWhile(function () { return _this.isAlive; }))
                    .subscribe(function (response) {
                    _this.redeemVoucherAPICallFlag = true;
                    if (response && response.status == '200') {
                        if (response.data) {
                            var vouchers = response.data.vouchers;
                            if (vouchers && vouchers.length > 0) {
                                vouchers.map(function (data) {
                                    if (data.status === 'KO') {
                                        redeemVoucherResults_1.push(data);
                                    }
                                });
                                if (redeemVoucherResults_1 && redeemVoucherResults_1.length > 0) {
                                    //CASE: THERE IS AN ERROR WITH ONE OF THE VOUCHERS
                                    //METHOD: DISPLAY THE WARNING MESSAGE TO THE PAYMENT PAGE REGARDING THE VOUCHER ISSUE
                                    redeemVoucherSuccessFlag_1 = false;
                                }
                                else {
                                    //CASE: ALL VOUCHERS ARE OK
                                    redeemVoucherSuccessFlag_1 = true;
                                }
                            }
                            else {
                                //CASE: THERE ARE NO VOUCHERS
                                redeemVoucherSuccessFlag_1 = true;
                            }
                        }
                        else {
                            redeemVoucherSuccessFlag_1 = true;
                        }
                    }
                    else {
                        //CASE: RESPONSE HAS ERROR STATUS
                        redeemVoucherSuccessFlag_1 = false;
                    }
                    if (redeemVoucherSuccessFlag_1) {
                        //CASE: PROCEED WITH THE INITIALIZATION OF PAYPAL BUTTON & POP-UP MODAL
                        _this.emitVoucherError.emit(null);
                        if (_this.savePaypalChecked) {
                            _this.INDRA_proceedInitializeBlueButton();
                        }
                        else {
                            _this.INDRA_proceedInitializeGoldButton();
                        }
                    }
                    else {
                        if (_this.savePaypalChecked) {
                            paypal.Buttons({
                                onInit: function (data, actions) {
                                    //METHOD: DISABLE THE BUTTON FROM OPENING THE PAYPAL POP-UP MODAL
                                    actions.disable();
                                },
                                style: {
                                    layout: 'horizontal',
                                    size: 'large',
                                    color: 'blue',
                                    shape: 'rect',
                                    label: 'pay',
                                    tagline: false
                                },
                                onClick: function (data, actions) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        this.emitLoader.emit(false);
                                        this.emitVoucherError.emit(redeemVoucherResults_1);
                                        return [2 /*return*/];
                                    });
                                }); }
                            }).render('#paypal-blue-button-indra');
                        }
                        else {
                            paypal.Buttons({
                                onInit: function (data, actions) {
                                    //METHOD: DISABLE THE BUTTON FROM OPENING THE PAYPAL POP-UP MODAL
                                    actions.disable();
                                },
                                style: {
                                    layout: 'horizontal',
                                    size: 'large',
                                    color: 'gold',
                                    shape: 'rect',
                                    label: 'pay',
                                    tagline: false
                                },
                                onClick: function (data, actions) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        this.emitLoader.emit(false);
                                        this.emitVoucherError.emit(redeemVoucherResults_1);
                                        return [2 /*return*/];
                                    });
                                }); }
                            }).render('#paypal-gold-button-indra');
                        }
                    }
                }, function (err) {
                    _this.redeemVoucherAPICallFlag = true;
                    //CASE: ERROR WITH THE INDRA_redeemVoucher RESPONSE
                    console.log('error', err);
                    _this.emitVoucherError.emit(redeemVoucherResults_1);
                });
            }
        }
        else {
            //CASE: PROCEED WITH THE INITIALIZATION OF PAYPAL BUTTON & POP-UP MODAL
            this.emitVoucherError.emit(null);
            if (this.savePaypalChecked) {
                this.INDRA_proceedInitializeBlueButton();
            }
            else {
                this.INDRA_proceedInitializeGoldButton();
            }
        }
    };
    INDRAPaypalPaymentComponent.prototype.INDRA_initializePaypalButtons = function () {
        this.INDRA_redeemVoucher();
    };
    INDRAPaypalPaymentComponent.prototype.INDRA_proceedInitializeGoldButton = function () {
        var _this = this;
        var userData = this.storage.get('userData');
        if (userData) {
            this.airlineID = userData.airlineID;
        }
        if (document.querySelector('#paypal-gold-button-indra').children.length > 0) {
            return; // prevent double render
        }
        paypal.Buttons({
            style: {
                layout: 'horizontal',
                size: 'large',
                color: 'gold',
                shape: 'rect',
                label: 'pay',
                tagline: false
            },
            onClick: function (data, actions) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.emitLoader.emit(true);
                    return [2 /*return*/];
                });
            }); },
            // start of order flow
            createOrder: function () { return __awaiter(_this, void 0, void 0, function () {
                var createOrderParam, data, error;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.totalFlightPrice = this.paymentService.getTotalFlightPrice();
                            this.cashPrice = this.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash);
                            this.currency = this.totalFlightPrice.currency;
                            this.points = this.totalFlightPrice.miles ? this.totalFlightPrice.miles : null;
                            createOrderParam = {
                                deviceChannel: 'browser',
                                sessionId: this.storage.get('token'),
                                currency: this.currency,
                                amount: +(this.cashPrice),
                                pnr: this.storage.get('bookingPnr'),
                                paymentMethodCode: PAYMENT_METHOD_PAYPAL,
                                paymentMethod: 'paypal'
                            };
                            if (this.isLoggedIn) {
                                if (this.points) {
                                    createOrderParam['points'] = this.points;
                                }
                                createOrderParam['flyTapId'] = this.airlineID;
                            }
                            return [4 /*yield*/, this.http.post(URL_PAYMENT_PAYPAL_CREATE_ORDER_NORMAL, createOrderParam).toPromise().catch(function () {
                                    _this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
                                })];
                        case 1:
                            data = _a.sent();
                            // handle error message "Error PNR paid IBE", user is trying to pay again after
                            // a failed PP payment attempt
                            // prevent user from trying another payment attempt
                            if (data && data.status === '400' && data.errors) {
                                error = data.errors;
                                if (error && error.length && error.some(function (err) { return err.code === '34' &&
                                    err.desc === "Error PNR paid IBE"; })) {
                                    this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.PAID_ERROR);
                                    return [2 /*return*/];
                                }
                            }
                            console.log(JSON.stringify(data));
                            if (data && data.status !== '200') {
                                this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
                            }
                            this.storage.set('idPaypal', data.data.idPaypal);
                            this.idOperation = data.data.idOperation;
                            return [2 /*return*/, data.data.idPaypal];
                    }
                });
            }); },
            onApprove: function (data) { return __awaiter(_this, void 0, void 0, function () {
                var onApproveParam, onApproveRes;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            onApproveParam = {
                                deviceChannel: 'browser',
                                sessionId: this.storage.get('token'),
                                currency: this.currency,
                                amount: +(this.cashPrice),
                                pnr: this.storage.get('bookingPnr'),
                                paymentMethodCode: PAYMENT_METHOD_PAYPAL,
                                paymentMethod: 'paypal',
                                idOperation: this.idOperation,
                                idPaypal: this.storage.get('idPaypal'),
                                payerID: data.payerID,
                                facilitatorAccessToken: data.facilitatorAccessToken,
                            };
                            if (this.isLoggedIn) {
                                if (this.points) {
                                    onApproveParam['points'] = this.points;
                                }
                                onApproveParam['flyTapId'] = this.airlineID;
                            }
                            return [4 /*yield*/, this.http.post(URL_PAYMENT_PAYPAL_CAPTURE_ORDER_NORMAL, onApproveParam).toPromise().catch(function () {
                                    _this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
                                })];
                        case 1:
                            onApproveRes = _a.sent();
                            if (onApproveRes) {
                                console.log(JSON.stringify(onApproveRes));
                                this.INDRA_handlePaypalReponse(onApproveRes);
                            }
                            return [2 /*return*/];
                    }
                });
            }); },
            onError: function (err) {
                // Show an error page here, when an error occurs
                this.emitLoader.emit(false);
                this.idOperation = null;
                this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
            },
            onCancel: function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // Show a cancel page, or return to cart
                    this.emitLoader.emit(false);
                    this.idOperation = null;
                    return [2 /*return*/];
                });
            }); }
        }).render('#paypal-gold-button-indra');
    };
    INDRAPaypalPaymentComponent.prototype.INDRA_proceedInitializeBlueButton = function () {
        var _this = this;
        var userData = this.storage.get('userData');
        if (userData) {
            this.airlineID = userData.airlineID;
        }
        paypal.Buttons({
            style: {
                layout: 'horizontal',
                size: 'large',
                color: 'blue',
                shape: 'rect',
                label: 'pay',
                tagline: false
            },
            onClick: function (data, actions) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.emitLoader.emit(true);
                    return [2 /*return*/];
                });
            }); },
            // start of order flow
            createBillingAgreement: function () { return __awaiter(_this, void 0, void 0, function () {
                var createBillingAgreementBody, data, error;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.totalFlightPrice = this.paymentService.getTotalFlightPrice();
                            this.cashPrice = this.INDRA_convertToCorrectDecimalPlace(this.totalFlightPrice.cash);
                            this.currency = this.totalFlightPrice.currency;
                            this.points = this.totalFlightPrice.miles ? this.totalFlightPrice.miles : null;
                            createBillingAgreementBody = {
                                deviceChannel: 'browser',
                                sessionId: this.storage.get('token'),
                                currency: this.currency,
                                amount: +(this.cashPrice),
                                pnr: this.storage.get('bookingPnr'),
                                paymentMethodCode: PAYMENT_METHOD_PAYPAL,
                                paymentMethod: 'paypal'
                                // idOperation: this.storage.get('idOperation'),
                            };
                            if (this.isLoggedIn) {
                                createBillingAgreementBody['flyTapId'] = this.airlineID;
                                if (this.points) {
                                    createBillingAgreementBody['points'] = this.points;
                                }
                            }
                            return [4 /*yield*/, this.http.post(URL_PAYMENT_PAYPAL_CREATE_ORDER_OCP, createBillingAgreementBody).toPromise().catch(function () {
                                    _this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
                                })];
                        case 1:
                            data = _a.sent();
                            // handle error message "Error PNR paid IBE", user is trying to pay again after
                            // a failed PP payment attempt
                            // prevent user from trying another payment attempt
                            if (data && data.status === '400' && data.errors) {
                                error = data.errors;
                                if (error && error.length && error.some(function (err) { return err.code === '34' &&
                                    err.desc === "Error PNR paid IBE"; })) {
                                    this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.PAID_ERROR);
                                    return [2 /*return*/];
                                }
                            }
                            console.log(JSON.stringify(data));
                            if (data && data.status !== '200') {
                                this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
                            }
                            this.storage.set('idPaypal', data.data.idPaypal);
                            this.idOperation = data.data.idOperation;
                            return [2 /*return*/, data.data.idPaypal];
                    }
                });
            }); },
            onApprove: function (data) { return __awaiter(_this, void 0, void 0, function () {
                var bodyOnApproveOcp, blueOnApproveRes;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            bodyOnApproveOcp = {
                                deviceChannel: 'browser',
                                sessionId: this.storage.get('token'),
                                currency: this.currency,
                                amount: +(this.cashPrice),
                                pnr: this.storage.get('bookingPnr'),
                                paymentMethodCode: PAYMENT_METHOD_PAYPAL,
                                paymentMethod: 'paypal',
                                idOperation: this.idOperation,
                                storeOCP: 'true',
                                idPaypal: data.billingToken,
                                orderID: data.orderID,
                                facilitatorAccessToken: data.facilitatorAccessToken
                            };
                            if (this.isLoggedIn) {
                                bodyOnApproveOcp['flyTapId'] = this.airlineID;
                                if (this.points) {
                                    bodyOnApproveOcp['points'] = this.points;
                                }
                            }
                            if (!!this.isCaptureOrderOcpLoading) return [3 /*break*/, 2];
                            this.isCaptureOrderOcpLoading = true;
                            return [4 /*yield*/, this.http.post(URL_PAYMENT_PAYPAL_CAPTURE_ORDER_OCP, bodyOnApproveOcp).toPromise().catch(function () {
                                    _this.isCaptureOrderOcpLoading = false;
                                    _this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.TECHNICAL_ERROR);
                                })];
                        case 1:
                            blueOnApproveRes = _a.sent();
                            if (blueOnApproveRes) {
                                this.isCaptureOrderOcpLoading = false;
                                console.log(JSON.stringify(blueOnApproveRes));
                                this.INDRA_handlePaypalReponse(blueOnApproveRes);
                            }
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); },
            onError: function (err) {
                // Show an error page here, when an error occurs
                this.emitLoader.emit(false);
                this.idOperation = null;
                this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
            },
            onCancel: function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    // Show a cancel page, or return to cart
                    this.emitLoader.emit(false);
                    this.idOperation = null;
                    return [2 /*return*/];
                });
            }); }
        }).render('#paypal-blue-button-indra');
    };
    INDRAPaypalPaymentComponent.prototype.INDRA_handlePaypalReponse = function (res) {
        if (res.status === '200' || res.status === '211') {
            if (res.data && res.data.statusBook) {
                switch (res.data.statusBook) {
                    case 'ISSUE_OK':
                        this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_OK);
                        break;
                    case 'ISSUE_KO':
                        this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_KO);
                        break;
                    case 'ISSUE_ERROR':
                        this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.SUCCESS_ISSUE_ERROR);
                        break;
                    default:
                        this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
                        break;
                }
            }
            else if (res.data && res.data.resultFCE === 'REJECT') {
                this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.REJECTED);
            }
            else {
                this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
            }
        }
        else if (res.status == '300' || res.status == '301') {
            this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
        }
        else if (res.status === '400' && res.errors && res.errors.length && res.errors.some(function (err) { return err.code === '34' &&
            err.desc === "Error PNR paid IBE"; })) {
            this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.PAID_ERROR);
            return;
        }
        else {
            this.paymentService.setPaypalPaymentResult(PAYPAL_PAYMENT_RESULT.ERROR);
        }
        /*
        if (res && res.data) {
            this.paymentService.setPaymentOperationID(res.data.idOperation);
            this.storage.set('idOperation', res.data.idOperation);
        }
        */
    };
    INDRAPaypalPaymentComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    /*
    INDRA_loadPaypalScripts(){

        var sdk = document.createElement('script');
        sdk.type = 'text/javascript';
        sdk.src = 'https://www.paypal.com/sdk/js?client-id='+ PAYPAL_CLIENT_ID + '&intent=capture&currency=EUR&commit=true&vault=true&components=buttons,funding-eligibility&debug=false';
        
        var paypalApi = document.createElement('script');
        paypalApi.setAttribute('data-version-4', '');
        paypalApi.setAttribute('async', '');
        paypalApi.type = 'text/javascript';
        paypalApi.src = 'https://www.paypalobjects.com/api/checkout.js';

        var paypalComponent = document.createElement('script');
        paypalComponent.setAttribute('async', '');
        paypalComponent.type = 'text/javascript';
        paypalComponent.src = 'https://js.braintreegateway.com/web/3.60.0/js/paypal-checkout.min.js';

        let paypalScript = document.querySelector(`script[src="${paypalComponent.src}"]`) ?  true : false;
        let apiScript = document.querySelector(`script[src="${paypalComponent.src}"]`) ?  true : false;
        let sdkScript = document.querySelector(`script[src="${sdk.src}"]`) ?  true : false;

        if(!paypalScript && !apiScript && !sdkScript){
            // Paypal SDK
            document.head.appendChild(sdk);
            // Load PayPal's checkout.js Library.
            document.head.appendChild(paypalApi);
            // Load the PayPal Checkout component.
            document.head.appendChild(paypalComponent);
            this.INDRA_initializeButtons()
        } else if(paypalScript && apiScript && sdkScript){
            this.INDRA_initializeButtons()
        }
    }
    */
    INDRAPaypalPaymentComponent.prototype.INDRA_initializeButtons = function () {
        var _this = this;
        this.timer = setInterval(function () {
            if (_this.storage.get('bookingPnr') != null) {
                _this.INDRA_initializePaypalButtons();
                clearInterval(_this.timer);
            }
        }, 2000);
    };
    return INDRAPaypalPaymentComponent;
}());
export { INDRAPaypalPaymentComponent };
